import {
	START_FORCE_DISCONNECT_SOCKET,
	FORCE_DISCONNECT_SOCKET_SUCCESS,

	START_FORCE_CONNECT_SOCKET,
	FORCE_CONNECT_SOCKET_SUCCESS,

	START_FORCE_RECONNECT_SOCKET,
	FORCE_RECONNECT_SOCKET_SUCCESS,

	RUN_FORCE_RECONNECTING_SOCKET_STEP_ONE_DISCONNECT,
	RUN_FORCE_RECONNECTING_SOCKET_STEP_TWO_CONNECT,

	NAVIGATE_TO_OVER_PAGE,
} from './action-types';

export function forceDisconnectSocketAction() {
	return {
		type: START_FORCE_DISCONNECT_SOCKET,
	};
}

export function forceDisconnectSocketSuccessAction(disconnectType) {
	return {
		type: FORCE_DISCONNECT_SOCKET_SUCCESS,
		disconnectType,
	};
}

export function forceConnectSocketAction() {
	return {
		type: START_FORCE_CONNECT_SOCKET,
	};
}

export function forceConnectSocketSuccessAction() {
	return {
		type: FORCE_CONNECT_SOCKET_SUCCESS,
	};
}

export function forceReconnectSocketAction() {
	return {
		type: START_FORCE_RECONNECT_SOCKET,
	};
}

export function forceReconnectSocketSuccessAction() {
	return {
		type: FORCE_RECONNECT_SOCKET_SUCCESS,
	};
}

export function runForceReconnectingSocketStepOneDisconnectAction() {
	return {
		type: RUN_FORCE_RECONNECTING_SOCKET_STEP_ONE_DISCONNECT,
	};
}

export function runForceReconnectingSocketStepTwoConnectAction() {
	return {
		type: RUN_FORCE_RECONNECTING_SOCKET_STEP_TWO_CONNECT,
	};
}

export function navigateToOverPageAction() {
	return {
		type: NAVIGATE_TO_OVER_PAGE,
	};
}
